import * as React from 'react';
import PropTypes from 'prop-types';

const Lists = props => {
	return(
		<div id='all_lists'>
			<ul>
				{props.allLists.length > 0 && props.allLists
					.sort( (a,b) => a.name.toLowerCase().localeCompare(b.name, props.i18n.language.split('_')[0], {'sensitivity': 'base'}) )
					.map((item, i) =>
						<span key={i}>
							<li
								key={i}
								className={props.selectedList
									&& props.selectedList.id === item.id ? 'selected' : '' }
								onClick={() => props.select(item.id)}>
								{item.name}
							</li>
						</span>
					)
				}
			</ul>
		</div>
	)
}

Lists.propTypes = {
	selectedList: PropTypes.shape({
		id: PropTypes.string.isRequired,
	}).isRequired,
	i18n: PropTypes.shape({
		language: PropTypes.string,
	}).isRequired,
	allLists: PropTypes.array.isRequired,
};

Lists.defaultPropTypes = {
	i18n: {
		language: 'en_US',
	},
}

const mapStateToProps = (state) => ({
	selectedList: state.selectedList,
});

export default Lists;